module.exports = __webpack_public_path__ + "img/logo.4d6e5a27.png";